import {ActiveContent, AppLoadingInput, ContentState} from "./contentType";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState: ContentState = {
    activeContent: ActiveContent.Dashboard,
    isSidebarExpanded: false,
    isAppLoading: false,
    loadingText: ''
}

export const contentSlice = createSlice({
    name: 'content',
    initialState: initialState,
    reducers: {
        setActiveContent: (state, action: PayloadAction<ActiveContent>) => {
            state.activeContent = action.payload
        },

        setSidebarState: (state, action: PayloadAction<boolean>) => {
            state.isSidebarExpanded = action.payload
        },

        setIsAppLoading: (state, action: PayloadAction<AppLoadingInput>) => {
            state.isAppLoading = action.payload.isAppLoading
            state.loadingText = action.payload.loadingText
        }
    }
});

export const {
    setActiveContent,
    setSidebarState,
    setIsAppLoading
} = contentSlice.actions

export default contentSlice.reducer